import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-153f180e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "code-label"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "模块编码", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "code-tip-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "code-tip-content__title"
}, "命名规则"), /*#__PURE__*/_createElementVNode("div", {
  class: "code-tip-content__row"
}, [/*#__PURE__*/_createTextVNode(" · 仅支持 "), /*#__PURE__*/_createElementVNode("em", null, "字母"), /*#__PURE__*/_createTextVNode(" / "), /*#__PURE__*/_createElementVNode("em", null, "数字"), /*#__PURE__*/_createTextVNode(" / "), /*#__PURE__*/_createElementVNode("em", null, "下划线")]), /*#__PURE__*/_createElementVNode("div", {
  class: "code-tip-content__row"
}, "· 必须以字母开头"), /*#__PURE__*/_createElementVNode("div", {
  class: "code-tip-content__row"
}, [/*#__PURE__*/_createTextVNode(" · 示例： "), /*#__PURE__*/_createElementVNode("code", null, "verify_timeout")])], -1));
const _hoisted_4 = {
  class: "code-rule-badge"
};
const _hoisted_5 = {
  key: 0,
  class: "code-lock-tag"
};
import { computed, reactive, ref, watch } from 'vue';
import { InfoCircleFilled, LockOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleEditModal',
  props: {
    visible: {
      type: Boolean
    },
    module: null,
    defaultColumnId: null,
    currentModulesCount: null,
    onSubmit: null
  },
  emits: ["update:visible"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    /**
     * 模块新增 / 编辑弹窗
     * - 两个字段：模块名称（必填）+ 模块编码（必填，格式校验）
     * - 模块编码首次保存后锁定不可改（codeLocked=true）
     * - 「所属栏目」字段已拆分到独立的 ModuleMoveModal，本弹窗不再承担移动职责
     * - 内联红字校验（不用 toast）
     * - 提交按钮带 confirm-loading + submitting guard 双重防连点
     */
    /** 用计算属性桥接 v-model:visible，让模板能用 v-model:open 直接绑 */
    const open = computed({
      get: () => props.visible,
      set: v => emit('update:visible', v)
    });
    const isEdit = computed(() => props.module != null);
    /** 编辑态下，已保存的编码锁定不可改（首次创建后即锁） */
    const codeLocked = computed(() => {
      var _props$module;
      return isEdit.value && !!((_props$module = props.module) !== null && _props$module !== void 0 && _props$module.moduleCode);
    });
    const form = reactive({
      moduleName: '',
      moduleCode: ''
    });
    /** 表单内联校验错误（红字提示在输入框下方） */
    const errors = reactive({
      moduleName: '',
      moduleCode: ''
    });
    const submitting = ref(false);
    /** 模块编码格式正则：以字母开头，后续可含字母/数字/下划线 */
    const MODULE_CODE_REGEX = /^[A-Za-z][A-Za-z0-9_]*$/;
    /**
     * 弹窗每次打开时初始化表单
     * - 编辑态：用现有 module 字段填充
     * - 新增态：清空
     * - 清空错误态
     */
    watch(() => props.visible, v => {
      if (!v) return;
      if (props.module) {
        form.moduleName = props.module.moduleName || '';
        form.moduleCode = props.module.moduleCode || '';
      } else {
        form.moduleName = '';
        form.moduleCode = '';
      }
      errors.moduleName = '';
      errors.moduleCode = '';
    }, {
      immediate: true
    });
    /**
     * 校验模块编码
     * @returns 校验通过返回空字符串；失败返回提示文案
     */
    const validateModuleCode = code => {
      if (!code) return '请填写模块编码';
      if (!MODULE_CODE_REGEX.test(code)) return '仅支持字母 / 数字 / 下划线，且以字母开头';
      return '';
    };
    /**
     * 提交
     * 编辑态：沿用原 columnId / sortOrder（移动归属在独立弹窗里处理）
     * 新增态：columnId 取 defaultColumnId，sortOrder 取 currentModulesCount
     */
    const handleOk = async () => {
      var _props$module$columnI, _props$module2;
      if (submitting.value) return;
      const name = form.moduleName.trim();
      const code = form.moduleCode.trim();
      errors.moduleName = name ? '' : '请填写模块名称';
      errors.moduleCode = codeLocked.value ? '' : validateModuleCode(code);
      if (errors.moduleName || errors.moduleCode) return;
      // 编辑态用原 columnId；新增态用 defaultColumnId
      const columnId = (_props$module$columnI = (_props$module2 = props.module) === null || _props$module2 === void 0 ? void 0 : _props$module2.columnId) !== null && _props$module$columnI !== void 0 ? _props$module$columnI : props.defaultColumnId;
      if (columnId == null) {
        // 防御性：理论上不会触发（页面没栏目时不会展示「新增模块」按钮）
        return;
      }
      submitting.value = true;
      try {
        var _props$module$id, _props$module3, _props$module$sortOrd, _props$module4;
        const ok = await props.onSubmit({
          id: (_props$module$id = (_props$module3 = props.module) === null || _props$module3 === void 0 ? void 0 : _props$module3.id) !== null && _props$module$id !== void 0 ? _props$module$id : null,
          columnId,
          moduleName: name,
          moduleCode: code,
          sortOrder: (_props$module$sortOrd = (_props$module4 = props.module) === null || _props$module4 === void 0 ? void 0 : _props$module4.sortOrder) !== null && _props$module$sortOrd !== void 0 ? _props$module$sortOrd : props.currentModulesCount
        });
        if (ok) {
          emit('update:visible', false);
        }
      } finally {
        submitting.value = false;
      }
    };
    const handleCancel = () => {
      emit('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: _unref(open),
        "onUpdate:open": _cache[4] || (_cache[4] = $event => _isRef(open) ? open.value = $event : null),
        title: _unref(isEdit) ? '编辑模块' : '新增模块',
        "confirm-loading": submitting.value,
        "mask-closable": false,
        "ok-text": "确定",
        "cancel-text": "取消",
        onOk: handleOk,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          layout: "vertical",
          model: form
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "模块名称",
            required: "",
            "validate-status": errors.moduleName ? 'error' : '',
            help: errors.moduleName
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: form.moduleName,
              "onUpdate:value": [_cache[0] || (_cache[0] = $event => form.moduleName = $event), _cache[1] || (_cache[1] = $event => errors.moduleName = '')],
              placeholder: "请输入模块名称",
              maxlength: 30,
              "show-count": "",
              "allow-clear": "",
              onPressEnter: handleOk
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["validate-status", "help"]), _createVNode(_component_a_form_item, {
            required: "",
            "validate-status": errors.moduleCode ? 'error' : '',
            help: errors.moduleCode
          }, {
            label: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_hoisted_2, _createVNode(_component_a_tooltip, {
              placement: "top"
            }, {
              title: _withCtx(() => [_hoisted_3]),
              default: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_unref(InfoCircleFilled)), _createTextVNode(" 命名规则 ")])]),
              _: 1
            }), _unref(codeLocked) ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_unref(LockOutlined)), _createTextVNode(" 已锁定 ")])) : _createCommentVNode("", true)])]),
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: form.moduleCode,
              "onUpdate:value": [_cache[2] || (_cache[2] = $event => form.moduleCode = $event), _cache[3] || (_cache[3] = $event => errors.moduleCode = '')],
              disabled: _unref(codeLocked),
              placeholder: _unref(codeLocked) ? '已锁定，不可修改' : '请输入英文/数字/下划线，例如 verify_timeout',
              maxlength: 50
            }, null, 8, ["value", "disabled", "placeholder"])]),
            _: 1
          }, 8, ["validate-status", "help"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "title", "confirm-loading"]);
    };
  }
});